<template>
  <div>
    <!-- 列表 -->
    <b-table
      id="data-table"
      hover
      :fields="fields"
      :items="items"
      :busy="tableLoading"
      :show-empty="true"
      primary-key="ID"
      empty-text="暂无数据"
      :no-local-sorting="true"

    >
      <template v-slot:table-busy>
        <div class="my-2 d-flex justify-content-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <a :href="row.item.downloadUrl">下载</a>
      </template>

    </b-table>

  </div>
</template>

<script>
import * as paperDownloadFacade from "../../../api/paper-download-facade.js";

export default {
  // validations:
  data() {
    return {
      fields: [
        {
          key: "downloadType",
          label: "任务类型",
          thClass: "blank"
        },
        {
          key: "criteria",
          label: "下载条件"
        },
        {
          key: "createTime",
          label: "提交时间"
        },
        {
          key: "statusMessage",
          label: "处理状态"
        },
        {
          key: "totalQty",
          label: "总条数"
        },
        {
          key: "succeedQty",
          label: "成功条数"
        },
        {
          key: "failedQty",
          label: "失败条数"
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: [], // 表格数据
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      // 以上为页面状态控制参数
      // 以下为表单校验规则

      // 以上为表单校验规则
    };
  },

  mounted(){
    this.list()
  },

  methods: {
    list(){
      this.tableLoading = true; // 打开表格的Loading状态
      paperDownloadFacade
        .listMyDownloads() // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });

    },

  },
}

</script>